export const PageHead = ({ kicker, title, desc, children }) => (
  <section className="mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-6 sm:pt-20">
    <div className="rise">
      <div className="kicker">{kicker}</div>
      <h1 className="font-disp mt-3 text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl" data-testid="page-title">{title}</h1>
      {desc && <p className="mt-5 max-w-2xl text-sm leading-8 text-slate-400 sm:text-base">{desc}</p>}
      {children}
    </div>
  </section>
);

export const Section = ({ children, className = "" }) => <section className={`mx-auto max-w-7xl px-4 sm:px-6 ${className}`}>{children}</section>;

export const Bullets = ({ items = [], className = "" }) => (
  <ul className={`space-y-2.5 ${className}`}>
    {items.map((t, i) => (
      <li key={i} className="flex gap-3 text-sm leading-7 text-slate-300">
        <span className="mt-[11px] h-1.5 w-1.5 shrink-0 rotate-45 bg-sky-400 shadow-[0_0_8px_#38bdf8]" />
        <span>{t}</span>
      </li>
    ))}
  </ul>
);

export const Tag = ({ children, tone = "ice" }) => {
  const tones = { ice: "border-sky-400/30 bg-sky-400/10 text-sky-300", gold: "border-amber-400/40 bg-amber-400/10 text-amber-300", mute: "border-slate-500/30 bg-slate-500/10 text-slate-300" };
  return <span className={`inline-flex items-center rounded-full border px-3 py-1 text-[11px] font-semibold ${tones[tone]}`}>{children}</span>;
};

export const Loading = () => (
  <div className="mx-auto grid max-w-7xl gap-6 px-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="loading">
    {[0, 1, 2].map((i) => <div key={i} className="h-72 animate-pulse rounded-2xl bg-slate-900/70" />)}
  </div>
);

export const Empty = ({ text }) => (
  <div className="glass mx-auto max-w-xl rounded-2xl p-10 text-center text-sm text-slate-400" data-testid="empty-state">{text}</div>
);

export const TicketCta = ({ href, text = "للطلب افتح تذكرة في ديسكورد المدينة وراح يتم خدمتك مباشرة." }) => (
  <Section className="mt-16">
    <div className="glass flex flex-col items-start justify-between gap-5 rounded-2xl p-8 sm:flex-row sm:items-center">
      <p className="text-sm leading-7 text-slate-300">{text}</p>
      <a href={href} target="_blank" rel="noreferrer" className="btn-ice shrink-0" data-testid="ticket-cta-btn">افتح تذكرة في الديسكورد</a>
    </div>
  </Section>
);
